import { TextField, Button as MuiButton } from "@material-ui/core";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { Modal } from "vqp-common";
import { Button } from "../LogisticsIntegration/LogisticsIntegration";
import { FormContainer, FormlLabelPartial, FormPartialDiv, Wrapper, Footer } from "../style";
import { LogisticalLevelTable } from "./LogisticalLevelTable";

export const LogisticalLevel = (props) => {

    const { formik, logisticalLevels, onAddLogisticalLevel, onEditLogisticalLevel } = props;

    const [deleteModal, setDeleteModal] = useState({ open: false, index: undefined });
    const [editModal, setEditModal] = useState({ open: false, item: undefined });

    const editForm = useFormik({
        initialValues: {
            logisticalLevelUntil: '',
            logisticalLevelValue: ''
        }
    })

    const onEdit = () => {
        const newArray = logisticalLevels.map((value, index) => {
            if (index === editModal.item.index) {
                return {
                    radius: editForm.values.logisticalLevelUntil,
                    value: Number(editForm.values.logisticalLevelValue.toString().replace(',', '.'))
                }
            }
            return value;
        })
        onEditLogisticalLevel(newArray);
        setEditModal({ open: false, item: undefined })
        editForm.resetForm();
    }

    const onDelete = (index) => {
        const newArray = logisticalLevels.filter((value, vIndex) => index !== vIndex);
        onEditLogisticalLevel(newArray);
        setDeleteModal({ open: false, index: undefined })
    }

    useEffect(() => {
        editForm.setValues({
            logisticalLevelUntil: editModal?.item?.radius,
            logisticalLevelValue: editModal?.item?.value,
        })
    }, [editModal.item])

    return (
        <>
            <FormContainer center>
                <FormPartialDiv>
                    <FormlLabelPartial style={{ marginRight: '6px !important' }}>Até (km):</FormlLabelPartial>
                    <TextField
                        style={{ width: 100, marginBottom: 3 }}
                        InputProps={{ inputProps: { min: 0 } }}
                        required
                        variant="outlined"
                        placeholder="Ex: 10"
                        size="small"
                        type="number"
                        {...formik.getFieldProps("logisticalLevelUntil")}
                    />
                </FormPartialDiv>
                <FormPartialDiv>
                    <FormlLabelPartial style={{ marginRight: '6px !important' }}>Valor (R$):</FormlLabelPartial>
                    <TextField
                        style={{ width: 100, marginBottom: 3 }}
                        InputProps={{ inputProps: { min: 0 } }}
                        required
                        variant="outlined"
                        placeholder="Ex: 0,00"
                        size="small"
                        type="number"
                        {...formik.getFieldProps("logisticalLevelValue")}
                    />
                </FormPartialDiv>
                <Button
                    className="primary"
                    style={{ width: '125px' }}
                    onClick={() => {
                        if ((formik.values.logisticalLevelValue !== undefined && formik.values.logisticalLevelValue !== '') && (formik.values.logisticalLevelUntil !== undefined && formik.values.logisticalLevelUntil !== '')) {
                            onAddLogisticalLevel({
                                logisticalLevelValue: formik.values.logisticalLevelValue,
                                logisticalLevelUntil: formik.values.logisticalLevelUntil
                            });
                        }
                    }}
                >
                    Adicionar
                </Button>
            </FormContainer>

            <LogisticalLevelTable
                logisticalLevels={logisticalLevels}
                onDelete={(logisticalLevel) => setDeleteModal({ open: true, index: logisticalLevels.findIndex((val) => val.radius === logisticalLevel.radius) })}
                onEdit={(logisticalLevel) => setEditModal({ open: true, item: { ...logisticalLevel, index: logisticalLevels.findIndex((val) => val.radius === logisticalLevel.radius) } })}
            />

            {
                editModal.open && (
                    <Modal isOpen={!!editModal.open} onClose={() => setEditModal({ open: false, item: undefined })}>
                        <Wrapper>
                            <FormContainer center>
                                <FormPartialDiv>
                                    <FormlLabelPartial style={{ marginRight: '6px !important' }}>Até (km):</FormlLabelPartial>
                                    <TextField
                                        style={{ width: 100, marginBottom: 3 }}
                                        required
                                        variant="outlined"
                                        placeholder="Ex: 10"
                                        size="small"
                                        type="number"
                                        {...editForm.getFieldProps("logisticalLevelUntil")}
                                    />
                                </FormPartialDiv>
                                <FormPartialDiv>
                                    <FormlLabelPartial style={{ marginRight: '6px !important' }}>Valor (R$):</FormlLabelPartial>
                                    <TextField
                                        style={{ width: 100, marginBottom: 3 }}
                                        required
                                        variant="outlined"
                                        placeholder="Ex: 0,00"
                                        size="small"
                                        type="number"
                                        {...editForm.getFieldProps("logisticalLevelValue")}
                                    />
                                </FormPartialDiv>
                                <Button
                                    className="primary"
                                    style={{ width: '125px' }}
                                    onClick={() => {
                                        if ((editForm.values.logisticalLevelValue !== undefined && editForm.values.logisticalLevelValue !== '') && (editForm.values.logisticalLevelUntil !== undefined && editForm.values.logisticalLevelUntil !== '')) {
                                            onEdit();
                                        }
                                    }}
                                >
                                    Editar
                                </Button>
                            </FormContainer>
                        </Wrapper>
                    </Modal>
                )
            }

            {
                deleteModal.open && (
                    <Modal isOpen={deleteModal.open} onClose={() => setDeleteModal({ open: false, index: undefined })} boxWidth={"450px"}>
                        <Wrapper>
                            Tem certeza que deseja excluir?
                            <Footer>
                                <MuiButton onClick={() => setDeleteModal({ open: false, index: undefined })}>
                                    Cancelar
                                </MuiButton>
                                <MuiButton color="secondary" onClick={() => onDelete(deleteModal.index)}>
                                    Excluir
                                </MuiButton>
                            </Footer>
                        </Wrapper>

                    </Modal>
                )
            }
        </>
    )
}
